import { render } from "./ImageEditor.vue?vue&type=template&id=02ca08be&scoped=true"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"

import "./ImageEditor.vue?vue&type=style&index=0&id=02ca08be&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ca08be"]])

export default __exports__